// Stickitee: toggle a "scrolled" class so the sticky header compacts on scroll.
(function () {
  var threshold = 30;
  function update() {
    document.documentElement.classList.toggle('stk-scrolled', window.scrollY > threshold);
  }
  window.addEventListener('scroll', update, { passive: true });
  update();
})();
